export default __webpack_public_path__ + "static/media/PadronSeries_Hdr.29ae6407.jpg";